import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";  // Import getAuth for authentication
import { getFirestore } from "firebase/firestore";  // Import Firestore for db
import { getStorage } from "firebase/storage";  // Optional, if you're using storage

const firebaseConfig = {
    apiKey: "AIzaSyAhhZLQQd-xuHiubRHMnqIvwSg8Sx2FdLs",
    authDomain: "hero-services-4d3fb.firebaseapp.com",
    projectId: "hero-services-4d3fb",
    storageBucket: "hero-services-4d3fb.firebasestorage.app",
    messagingSenderId: "155620215046",
    appId: "1:155620215046:web:29142d05c8be7612bf3687"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);  // Initialize Firebase Authentication
const db = getFirestore(app);  // Initialize Firestore
const storage = getStorage(app);  // Initialize Firebase Storage (if needed)

export { auth, db, storage };
